<template>
  <div class="kt-grid kt-grid--ver kt-grid--root">
    <div
      class="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v6 kt-login--signin"
      id="kt_login"
    >
      <div
        class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile"
      >
        <div
          class="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside"
        >
          <div class="kt-login__wrapper">
            <div class="kt-login__container auth-form">
              <div class="kt-login__body">
                <div class="kt-login__logo">
                  <router-link :to="{ name: 'login' }">
                    <img :src="site.meta.default.logo" />
                  </router-link>
                </div>

                <GuestUpdatePassword
                  v-if="orderSummary"
                  :order-summary="orderSummary"
                />
                <template v-if="!loadingOrderSummary && !orderSummary">
                  <div
                    v-if="loginForm"
                    class="kt-login__signin col-sm-12 col-md-12 col-lg-10 col-xl-8 col-12 mx-auto"
                  >
                    <div class="kt-head px-0">
                      <h3 class="kt-title">Log into your account</h3>
                    </div>
                    <div>
                      <Alert v-if="successMessage" variant="success">
                        {{ successMessage }}
                      </Alert>

                      <Alert v-if="errorMessage" variant="danger">
                        {{ errorMessage }}
                      </Alert>

                      <div
                        class="alert alert-solid-danger alert-bold fade show"
                        role="alert"
                        v-if="errors.email"
                      >
                        <div class="alert-icon">
                          <i class="flaticon-questions-circular-button"></i>
                        </div>
                        <div class="alert-text">{{ errors.email[0] }}</div>
                        <div class="alert-close">
                          <button
                            type="button"
                            class="close"
                            data-dismiss="alert"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">
                              <i class="la la-close"></i>
                            </span>
                          </button>
                        </div>
                      </div>
                      <form class="kt-form" @submit.prevent="submit">
                        <div class="form-group">
                          <input
                            class="form-control"
                            type="email"
                            placeholder="Email"
                            v-model="form.email"
                            required
                          />
                        </div>
                        <div class="form-group">
                          <input
                            class="form-control"
                            type="password"
                            placeholder="Password"
                            v-model="form.password"
                            required
                          />
                          <a
                            class="float-right text-primary"
                            href="#"
                            @click="startResetPasswordProcess"
                            ><strong>Forgot Password</strong></a
                          >
                        </div>
                        <div class="kt-login__extra form-group">
                          <label class="kt-checkbox">
                            <input type="checkbox" v-model="form.remember" />
                            Remember me
                            <span></span>
                          </label>
                          <!-- <a href="javascript:;" id="kt_login_forgot">Forget Password ?</a> -->
                        </div>

                        <div class="form-group">
                          <button
                            type="submit"
                            id="kt_login_signin_submit"
                            class="btn btn-brand w-100 btn-elevate"
                            :disabled="busy"
                          >
                            <div
                              class="d-flex justify-content-center align-items-center"
                            >
                              <span>Sign In</span>
                              <div
                                v-if="busy"
                                class="spinner-border spinner-border-sm ml-2"
                                role="status"
                              >
                                <span class="sr-only">Loading...</span>
                              </div>
                            </div>
                          </button>
                        </div>
                      </form>
                    </div>

                    <div class="kt-login__account" style="font-size: 1.2em;">
                      <span class="kt-login__account-msg">
                        Don't have an account yet?
                      </span>
                      <router-link
                        :to="{ name: 'register' }"
                        class="font-weight-bold mx-2 kt-login__account-link"
                        style="font-size: inherit"
                      >
                        Sign Up!
                      </router-link>
                    </div>
                  </div>

                  <div
                    v-if="secondStep"
                    class="kt-login__register col-sm-12 col-md-12 col-lg-10 col-xl-8 col-12 mx-auto"
                  >
                    <div>
                      <h3 class="kt-title">Reset your password</h3>
                    </div>
                    <div class="form-group">
                      Please enter your email address. We will send you a
                      verification code to the email address.
                    </div>
                    <div>
                      <div class="form-group">
                        <div class="row">
                          <div class="col">
                            <input
                              v-model="verification.email"
                              class="form-control"
                              placeholder="Enter Your Email"
                              type="text"
                            />
                            <span
                              v-if="verification.emailErrorMessage"
                              class="form-text text-danger"
                            >
                              {{ verification.emailErrorMessage }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <button
                          id="kt_login_signin_submit"
                          :disabled="busy"
                          class="btn btn-brand w-100 btn-elevate"
                          type="submit"
                          @click="submitEmailForVerification"
                        >
                          <span>Submit</span>
                          <span
                            v-if="busy"
                            class="spinner-border spinner-border-sm ml-2"
                            role="status"
                          >
                          </span>
                        </button>
                      </div>
                      <a class="text-wrap mt-3" href="#" @click="backToLogin"
                        >Back to Log in page</a
                      >
                    </div>
                  </div>

                  <div
                    v-if="thirdStep"
                    class="kt-login__register col-sm-12 col-md-12 col-lg-10 col-xl-8 col-12 mx-auto"
                  >
                    <div>
                      <h3 class="kt-title">Confirm your email</h3>
                    </div>

                    <div>
                      <div class="form-group">
                        <div class="row">
                          <div class="col">
                            <input
                              v-model="verification.verification_code"
                              class="form-control"
                              placeholder="Code"
                              type="text"
                            />
                            <span
                              v-if="verification.codeErrorMessage"
                              class="form-text text-danger"
                            >
                              {{ verification.codeErrorMessage }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <button
                          id="kt_login_signin_submit"
                          class="btn btn-brand w-100 btn-elevate"
                          type="submit"
                          @click="verify"
                        >
                          <span>Verify</span>
                        </button>
                      </div>
                      <a class="text-wrap mt-3" href="#" @click="backToLogin"
                        >Back to Log in page</a
                      >
                    </div>
                  </div>

                  <div
                    v-if="fourthStep"
                    class="kt-login__register col-sm-12 col-md-12 col-lg-10 col-xl-8 col-12 mx-auto"
                  >
                    <div>
                      <h3 class="kt-title">Set New password</h3>
                    </div>
                    <div class="form-group">
                      Please, enter your new password twice, so we can verify
                      you typed in correctly.
                    </div>
                    <div>
                      <div class="form-group">
                        <input
                          v-model="verification.password"
                          class="form-control"
                          placeholder="Password"
                          type="password"
                        />
                      </div>

                      <div class="form-group">
                        <input
                          v-model="verification.confirmPassword"
                          class="form-control"
                          placeholder="Confirm Password"
                          type="password"
                        />
                        <span
                          v-if="verification.confirmPasswordError"
                          class="form-text text-danger"
                        >
                          {{ verification.confirmPasswordError }}
                        </span>
                      </div>

                      <div class="form-group">
                        <button
                          id="kt_login_signin_submit"
                          :disabled="busy"
                          class="btn btn-brand w-100 btn-elevate"
                          type="submit"
                          @click="updatePassword"
                        >
                          <span>Reset Password</span>
                          <span
                            v-if="busy"
                            class="spinner-border spinner-border-sm ml-2"
                            role="status"
                          >
                          </span>
                        </button>
                      </div>

                      <a class="text-wrap mt-3" href="#" @click="backToLogin"
                        >Back to Log in page</a
                      >
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div
          :style="{ backgroundImage: `url(${this.banner})` }"
          class="kt-grid__item kt-grid__item--fluid kt-grid__item--center kt-grid kt-grid--ver kt-login__content"
        >
          <div class="kt-login__section">
            <div class="kt-login__block mx-5">
              <h3 class="kt-login__title">
                {{ site.meta.login.hero_section_title }}
              </h3>
              <div class="kt-login__desc">
                {{ site.meta.login.hero_section_description }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import Alert from "@/components/Alert.vue";
import GuestUpdatePassword from "@/components/GuestUpdatePassword.vue";
import { decrypt } from "@/helpers/support.js";

export default {
  components: {
    Alert,
    GuestUpdatePassword,
  },

  data() {
    return {
      banner: "",
      form: {
        email: "",
        password: "",
        remember: true,
      },
      errors: {},
      successMessage: "",
      errorMessage: "",
      busy: false,
      verification_email: "",
      verification: {
        email: "",
        emailErrorMessage: "",
        verification_code: "",
        codeErrorMessage: "",
        password: "",
        confirmPassword: "",
        confirmPasswordError: "",
      },
      loginForm: true,
      secondStep: false,
      thirdStep: false,
      fourthStep: false,

      loadingOrderSummary: false,
      orderSummary: null,
    };
  },
  computed: {
    ...mapGetters({
      site: "site/site",
    }),
  },
  created() {
    if (this.$route.query?.ref) {
      const orderID = decrypt(this.$route.query?.ref);
      if (orderID) {
        this.loadingOrderSummary = true;
        axios
          .get("guest-order-summary/" + orderID)
          .then((response) => {
            if (
              response &&
              response.data &&
              response.data.user.registration_method &&
              !response.data.user.last_login
            ) {
              this.orderSummary = response.data;
            }
          })
          .finally(() => {
            this.loadingOrderSummary = false;
          });
      }
    }
  },
  mounted() {
    this.banner = this.site.meta.login.banner;

    if (this.$route.query?.success === "account-created") {
      this.successMessage = "Account created successfully!";
    }
  },
  methods: {
    ...mapActions({
      login: "auth/login",
      sendVerificationCode: "auth/sendCodeForResetPassword",
      verifyCode: "auth/verify",
      resetPassword: "auth/resetPassword",
    }),

    submit() {
      if (this.busy) {
        return;
      }

      this.busy = true;
      this.login({
        credential: this.form,
        remember: this.form.remember,
      })
        .then(() => {
          this.$router.replace({
            name: "home",
          });
        })
        .catch((error) => {
          this.errors = error.response.data.errors || {};
          this.errorMessage = error.response.data.message;
        })
        .finally(() => {
          this.busy = false;
        });
    },

    startResetPasswordProcess() {
      this.loginForm = false;
      this.banner = this.site.meta.login.second_banner;
      this.secondStep = true;
      this.thirdStep = false;
      this.fourthStep = false;
    },

    backToLogin() {
      this.busy = false;
      this.loginForm = true;
      this.banner = this.site.meta.login.banner;
      this.secondStep = false;
      this.thirdStep = false;
      this.fourthStep = false;
    },

    submitEmailForVerification() {
      this.busy = true;

      this.sendVerificationCode(this.verification).then((data) => {
        if (data.data.success) {
          this.busy = false;

          this.loginForm = false;
          this.secondStep = false;
          this.thirdStep = true;
          this.fourthStep = false;
        }

        if (!data.data.success) {
          this.busy = false;

          this.verification.emailErrorMessage =
            "We did not find your email, please sign in.";
        }
      });
    },

    verify() {
      this.verifyCode(this.verification).then((data) => {
        if (data.data.success) {
          this.loginForm = false;
          this.secondStep = false;
          this.thirdStep = false;
          this.fourthStep = true;
        }

        if (!data.data.success) {
          this.verification.emailErrorMessage = "Verification code mismatched";
          this.busy = false;
        }
      });
    },

    updatePassword() {
      if (this.verification.password !== this.verification.confirmPassword) {
        this.verification.confirmPasswordError =
          "The password confirmation does not match.";

        return;
      }

      if (this.verification.password.length < 8) {
        this.verification.confirmPasswordError =
          "The password must be at least 8 characters.";

        return;
      }

      this.busy = true;

      this.resetPassword(this.verification).then((data) => {
        if (data.data.success) {
          this.busy = false;
          this.form.email = this.verification.email;
          this.form.password = this.verification.confirmPassword;

          this.submit();
        }

        if (!data.data.success) {
          this.verification.confirmPasswordError =
            "Verification failed! Please try again.";
        }
      });
    },
  },
};
</script>

<style src="../../assets/css/auth.css"></style>
<style>
.kt-login__signin .kt-head .kt-title:before,
.kt-login__signin .kt-head .kt-title:after {
  background: none;
}
</style>
